module.exports = __webpack_public_path__ + "static/JetBrainsMono-Italic-9d9d24d12647f710199eb4df8780a01c.woff";